import React, {useState} from 'react';
import {useRouter} from 'next/router';
import {Loader2} from 'lucide-react';

const CustomButton = ({className, children, href}) => {
	const [isLoading, setIsLoading] = useState(false);
	const router = useRouter();

	const handleClick = async () => {
		setIsLoading(true);
		await router.push(href);
	};

	return (
		<button
			onClick={handleClick}
			disabled={isLoading}
			className={`
        ${className}
        relative
        inline-flex
        items-center
        justify-center
        transition-colors
        duration-200
        disabled:cursor-not-allowed
        disabled:opacity-70
        hover:brightness-110
        `}
		>
			{isLoading ? <Loader2 className='w-5 h-5 animate-spin mr-2' /> : null}
			{children}
		</button>
	);
};

export default CustomButton;
